import { FormGroup, UntypedFormGroup } from '@angular/forms';

import { isNotNullOrEmptyString } from '../../../../../shared/utils/functions';
import { DetailsOverlayComponent } from './details-overlay.component';
import { UpgradedFormGroup } from './details-overlay.model';
import moment from 'moment';

export class DetailsOverlayValidators {
  static notEmptySpaceUOM(valueUomFG: UntypedFormGroup): { [key: string]: any } {
    const valueUOM = valueUomFG.value;
    return isNotNullOrEmptyString(valueUOM.spaceSize) && !isNotNullOrEmptyString(valueUOM.spaceSizeUOM)
      ? { emptyUOM: true }
      : null;
  }
  static notEmptyRentUOM(valueUomFG: UntypedFormGroup): { [key: string]: any } {
    const valueUOM = valueUomFG.value;
    return isNotNullOrEmptyString(valueUOM.rentRate) && !isNotNullOrEmptyString(valueUOM.rentRateUOM)
      ? { emptyUOM: true }
      : null;
  }

  static leaseDateValidator(leaseFG: UntypedFormGroup): { [key: string]: any } {
    const { leaseStartDate, leaseEndDate } = leaseFG.value;
    if ((leaseStartDate && leaseEndDate && leaseEndDate >= leaseStartDate) || !leaseStartDate || !leaseEndDate) {
      leaseFG.controls['leaseStartDate'].setErrors(null);
      return null;
    }
    leaseFG.controls['leaseStartDate'].setErrors({ invalidDates: true });
    return { invalidDates: true };
  }

  static spaceSizeLessThanFloorSize(valueSpaceSize: UpgradedFormGroup): { invalidSpaceSize: boolean } {
    const { floorId, containerRecordFloors, unaccountedSpace, data }: DetailsOverlayComponent =
      valueSpaceSize.component;
    const originalVal = data.getAreaSpace() || 0;
    const { floor_size } = containerRecordFloors.find(floor => floor.floor_id === floorId) || {};
    // * Disable validation if floor size is not defined...
    if (!floor_size) {
      return null;
    }

    const spaceSize = Number(valueSpaceSize.value.spaceSize?.replace(/\D/g, ''));
    //const spaceUnit = valueSpaceSize.value.spaceSizeUOM;
    const isSpaceGreaterThanFloor = (unaccountedSpace || 0) + originalVal < spaceSize;

    valueSpaceSize.component.overlayFormGroup.controls.formGroupSpace['controls']?.spaceSize?.markAsDirty();
    valueSpaceSize.warnings = isSpaceGreaterThanFloor ? { invalidSpaceSize: true } : null;

    return null;
  }

  static isAvailabilityVacant(valueUomFG: UpgradedFormGroup): { invalidVacancyAvailDate: boolean } {
    const rootFG = valueUomFG.root as FormGroup;
    if (!rootFG.controls) {
      return null;
    }

    const DATE_AVAILABLE_VALIDATOR = DetailsOverlayValidators.isDateAvailableValid;
    const dateAvailableControl = rootFG.get('dateAvailable');
    const isAvailabilityVacantValue: boolean = rootFG.get('vacant')?.value;
    /**
     * When vacant value is different than true, no Date Available Validation needs to happen
     * hence, if such validation exists in the control, remove it and validate once more
     */
    if (!isAvailabilityVacantValue) {
      if (dateAvailableControl.hasValidator(DATE_AVAILABLE_VALIDATOR)) {
        dateAvailableControl.removeValidators(DATE_AVAILABLE_VALIDATOR);
        dateAvailableControl.updateValueAndValidity();
      }
      return null;
    }

    dateAvailableControl.addValidators(DATE_AVAILABLE_VALIDATOR);
    dateAvailableControl.updateValueAndValidity();
    return null;
  }

  static isDateAvailableValid(valueUomFG: UpgradedFormGroup): { invalidVacancyAvailDate: boolean } {
    const rootFG = valueUomFG.root as FormGroup;
    if (!rootFG.controls) {
      return null;
    }
    const isAvailabilityVacantVal: boolean = rootFG.get('vacant')?.value;

    if (isAvailabilityVacantVal) {
      const dateAvailableControl = rootFG.get('dateAvailable');
      const availableDate = dateAvailableControl.value;
      const nowDate = moment(new Date());
      if (!availableDate || availableDate.isAfter(nowDate)) {
        dateAvailableControl.markAsDirty();
        return { invalidVacancyAvailDate: true };
      }
    }
    return null;
  }
}
